import React, { useEffect, useRef, useState } from 'react';
import { Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { mediaUrl } from '../../services/postsApi';

// Opens the phone's share sheet with the verse image (WhatsApp, Instagram Stories, etc.).
// The image is pre-fetched so navigator.share runs inside the tap (Safari requires it).
export const ShareVerseButton = ({ post, es }) => {
  const fileRef = useRef(null);
  const [ready, setReady] = useState(false);
  const name = `lumera-${(post.verse_reference || 'verse').replace(/[^\w]+/g, '-')}.jpg`;

  useEffect(() => {
    let alive = true;
    fetch(mediaUrl(post.image_url))
      .then((r) => r.blob())
      .then((b) => { if (alive) { fileRef.current = new File([b], name, { type: 'image/jpeg' }); setReady(true); } })
      .catch(() => {});
    return () => { alive = false; };
  }, [post.image_url, name]);

  const share = async () => {
    const file = fileRef.current;
    if (!file) return;
    try {
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: `${post.verse_reference || ''} — Lumera`.trim() });
        return;
      }
      const a = document.createElement('a');
      a.href = URL.createObjectURL(file);
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success(es ? 'Imagen descargada — compártela en WhatsApp o Instagram' : 'Image saved — share it on WhatsApp or Instagram');
    } catch (e) {
      if (e?.name !== 'AbortError') toast.error(es ? 'No se pudo compartir' : 'Could not share');
    }
  };

  return (
    <button onClick={share} disabled={!ready} className="ml-auto flex items-center gap-1.5 text-sm font-medium transition-opacity hover:opacity-70 disabled:opacity-40"
      aria-label={es ? 'Compartir' : 'Share'} data-testid={`post-share-verse-${post.id}`}>
      <Share2 className="w-5 h-5" />
      {es ? 'Compartir' : 'Share'}
    </button>
  );
};

export default ShareVerseButton;
